import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  productDetails: [],
  isLoading: true,
  isViewModalOpen: false,
  isSuccess: false,
  isError: false,
  message: "",
  response: {},
};

export const getProductDetails = createAsyncThunk(
  "products/getProductDetailsToView",
  async (productId, thunkAPI) => {
    console.log(thunkAPI.getState());
    const response = await axios.get(
      `${process.env.REACT_APP_API_KEY}/product/getproduct_details_with_mult_img/${productId}`
    );
    return response.data;
  }
);

const productDetailSlice = createSlice({
  name: "productDetails",
  initialState,
  reducers: {
    viewProduct: (state, action) => {
      state.isViewModalOpen = true;
    },

    closeViewModal: (state) => {
      state.isViewModalOpen = false;
      state.productDetails = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProductDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getProductDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isViewModalOpen = true;
      state.productDetails = action.payload.result;
      state.response = action.payload;
      state.imageUrl = action.payload.image_url;
    });
    builder.addCase(getProductDetails.rejected, (state, action) => {
      state.isLoading = false;
      console.error(action.payload.response.data);
    });
  },
});

export const { viewProduct, closeViewModal } = productDetailSlice.actions;
export default productDetailSlice.reducer;
